<vectronic-filter-header
  [title]="title()"
  (titleClicked)="toggled.emit()"
  (enabledFilterToggle)="toggled.emit()"
  [isFilterEnabled]="expanded()"
></vectronic-filter-header>

<div class="filter-body" [hidden]="!expanded()">
  <vectronic-datepicker
    [label]="title()"
    [value]="value()"
    [min]="min()"
    [max]="max()"
    [showFormatHint]="false"
    [openOnFocus]="true"
    (dateChange)="onDateChange($event)"
  ></vectronic-datepicker>
</div>
